export const Liferay = window.Liferay || {
    OAuth2: {
        getAuthorizeURL: () => "",
        getBuiltInRedirectURL: () => "",
        getIntrospectURL: () => "",
        getTokenURL: () => "",
        getUserAgentApplication: (_serviceName) => {},
    },
    OAuth2Client: {
        FromParameters: (_options) => {
            return {};
        },
        FromUserAgentApplication: (_userAgentApplicationId) => {
            return {};
        },
        fetch: (_url, _options = {}) => {},
    },
    Session: {
        on: function (event, callback) {
            console.log(`[Mock] Liferay.Session.on → ${event}`);
        },
        detach: function (event, callback) {
            console.log(`[Mock] Liferay.Session.detach → ${event}`);
        },
        getAttrs: () => ({
            timestamp: Date.now(),
            sessionLength: 900000,
            warningLength: 60000,
            sessionState: 'active',
            redirectUrl: "/c/portal/logout"
        }),
    },
    ThemeDisplay: {
        getCompanyGroupId: () => 0,
        getScopeGroupId: () => 0,
        getSiteGroupId: () => 0,
        getUser: () => 'Test',
        getPortalURL: () => '',
        getPathThemeImages: () => '',
        getUserEmail: () => 'Test@email.com',
        getUserId: () => '20122',
        getUserName: () => '',
        isSignedIn: () => {
            return true;
        },

    },
    authToken: "",
};
